import { IHttpApi } from '@cian/http-api/shared';

import { ResponseError } from '../../errors';
import {
  fetchCreateQuestionAnswer,
  TCreateQuestionAnswerResponse,
} from '../../repositories/newbuilding-reviews/v1/create-question-answer';
import { INewAnswer } from '../../types/newAnswer';
import { prepareNewAnswer } from '../../mappers/prepareNewAnswer';

export interface IFetchAnswerParams {
  httpApi: IHttpApi;
  parameters: {
    questionId: string;
    newAnswer: INewAnswer;
  };
}

export async function addQuestionAnswer({
  httpApi,
  parameters: { questionId, newAnswer },
}: IFetchAnswerParams): Promise<void> {
  const result: TCreateQuestionAnswerResponse = await fetchCreateQuestionAnswer({
    httpApi,
    parameters: prepareNewAnswer(questionId, newAnswer),
  });

  if (result.statusCode !== 200) {
    throw new ResponseError({
      domain: 'question#fetchAddQuestionAnswer',
      message: '',
    });
  }
}
